import { useContext } from 'react'
import { AuthenticationContext } from '../context/authentication.context'
import { SlackUser } from '../types'

export const useUser = () => {
  const { user } = useContext(AuthenticationContext)
  return user as SlackUser
}
